export default "__VITE_ASSET__7d2ba1ce__"